"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMedia = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const Media_1 = __importDefault(require("../media/Media"));
const PREFIX = "TwoPaneCarousel";
exports.classes = {
    brandIcon: `${PREFIX}-brandIcon`,
    image: `${PREFIX}-image`,
    leftPaneSlide: `${PREFIX}-leftPaneSlide`,
    text: `${PREFIX}-text`,
    controls: `${PREFIX}-controls`,
    cta: `${PREFIX}-cta`,
    wrapper: `${PREFIX}-wrapper`,
    leftPane: `${PREFIX}-leftPane`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    [`.${exports.classes.brandIcon}`]: {
        alignSelf: "start",
        height: "40px",
        marginBottom: "24px",
        fill: theme.colours.white
    },
    [`.${exports.classes.image}`]: {
        backgroundSize: "cover",
        backgroundPosition: "center center",
        maxHeight: "400px",
        marginBottom: "24px"
    },
    [`.${exports.classes.leftPaneSlide}`]: {
        justifyContent: "flex-start"
    },
    [`.${exports.classes.text}`]: {
        fontSize: "1rem"
    },
    [`.${exports.classes.controls}`]: {
        marginTop: "24px",
        [theme.breakpoints.up("md")]: {
            marginTop: "32px"
        }
    },
    [`.${exports.classes.cta}`]: {
        marginTop: "24px",
        minHeight: "48px",
        [theme.breakpoints.up("md")]: {
            marginTop: "32px"
        }
    },
    [`.${exports.classes.wrapper}`]: {
        marginTop: "48px",
        textAlign: "center"
    },
    [theme.breakpoints.up("md")]: {
        [`.${exports.classes.leftPane}`]: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: "504px"
        },
        [`.${exports.classes.image}`]: {
            maxHeight: "none",
            height: "504px",
            marginBottom: 0,
            "&::before": {
                content: "''"
            }
        },
        [`.${exports.classes.wrapper}`]: {
            textAlign: "left"
        }
    }
}));
exports.StyledMedia = (0, styles_1.styled)(Media_1.default)(({ theme }) => ({
    height: "200px",
    [theme.breakpoints.up("md")]: {
        height: "504px"
    }
}));
//# sourceMappingURL=data:application/json;base64,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